export function styleReconnectModal() {
	const modal = document.getElementById('components-reconnect-modal');
	if (modal && modal.shadowRoot && !modal.dataset.styled) {
		const style = document.createElement('style');
		style.textContent = `
			.components-reconnect-overlay {
				position: fixed;
				width: auto;
				height: auto;
				z-index: 10000;
				background: none;
				opacity: 0.8;
				pointer-events: none; /* Let clicks pass through outside the dialog */
			}

			.components-reconnect-overlay::before {
				display: none !important;
			}

			.components-reconnect-dialog {
				position: absolute;
				top: auto;
				left: auto;
				bottom: 1rem;
				right: 1rem;
				flex-direction: row;
				margin: 0;
				width: auto;
				max-width: 400px;
				background-color: black;
				color:white;
				box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
				border-radius: 8px;
				padding: 1rem;
				pointer-events: auto; /* Re-enable clicks on the dialog */
				transform: none;

			}
		`;
		modal.shadowRoot.appendChild(style);
		modal.dataset.styled = "true";
	}
}
